var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DashboardBanner"},[_c('h1',[_vm._v(_vm._s(_vm.$t('dashboardBanner.hello'))+", "+_vm._s(_vm.name)+"!")]),(_vm.subheader)?_c('h2',[_vm._v(_vm._s(_vm.subheader))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }